// @ts-check
import React from 'react'
import styles from './style.css'

/**
 * @param {{ title: string, children?: React.ReactChild }} props
 */
const Header = ({ title, children }) => (
  <>
    <h1 className={styles.header}>{title}</h1>
    {children ? <p className={styles.caption}>{children}</p> : null}
  </>
)

Header.defaultProps = {
  children: null
}

export { Header }
